import { Pipe, PipeTransform } from '@angular/core';
import { sanitizeHtml } from '../../utils';

@Pipe({
  name: 'encodeString',
  standalone: true,
})
export class EncodeStringPipe implements PipeTransform {
  /**
   * Encodes strings like <h1> asd </h1> to &lt;h1&gt; asd &lt;/h1&gt;
   * @param value
   * @returns
   */
  transform(value: string): string {
    return sanitizeHtml(value);
  }
}
